import { render, staticRenderFns } from "./technology_case.vue?vue&type=template&id=1256affe&scoped=true&"
import script from "./technology_case.vue?vue&type=script&lang=js&"
export * from "./technology_case.vue?vue&type=script&lang=js&"
import style0 from "./technology_case.vue?vue&type=style&index=0&id=1256affe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1256affe",
  null
  
)

export default component.exports